function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 11");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Learning-System",
  stroke: "current",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Main-Dashboard",
  transform: "translate(-812.000000, -135.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(813.000000, 135.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2,1 L14,1 C15.1045695,1 16,1.8954305 16,3 L16,21 L16,21 L11.732441,19.7251997 L8,21 L4.29806881,19.7251997 L0,21 L0,3 C-1.3527075e-16,1.8954305 0.8954305,1 2,1 Z",
  id: "Rectangle",
  stroke: "#A8A8A8"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#A8A8A8",
  x: 3,
  y: 6,
  width: 10,
  height: 1,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  fill: "#A8A8A8",
  x: 3,
  y: 10,
  width: 10,
  height: 1,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-8",
  fill: "#A8A8A8",
  x: 3,
  y: 14,
  width: 10,
  height: 1,
  rx: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  cx: 16,
  cy: 3,
  r: 3
}))));

var SvgForum = function SvgForum(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForum, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forum.e20cd9f6.svg";
export { ForwardRef as ReactComponent };